// removed by extract-text-webpack-plugin
module.exports = {"container":"WaitingRoomHistory__container___2ee7l"};